import {Component} from '@angular/core';
import * as moment from 'moment';
import {SliderPage} from '../slider-page/slider-page';

@Component({
  selector: 'energylevel-page',
  templateUrl: 'energylevel-page.html',
  styleUrls: ['energylevel-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class EnergylevelPage extends SliderPage {}
